export default __webpack_public_path__ + "static/media/nuevobanner.a7d05381.jpg";